import React from "react";
import { motion } from "framer-motion";

// Editorial marquee: repeating couple names in outlined Playfair
export const Marquee = ({ text = "George & Amy", separator = "•" }) => {
  const unit = `${text}  ${separator}  `;
  const line = Array(6).fill(unit).join("");
  return (
    <div className="relative overflow-hidden bg-navy py-8 md:py-12" data-testid="marquee">
      <div className="flex whitespace-nowrap">
        <motion.div
          className="flex whitespace-nowrap"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration: 30, ease: "linear", repeat: Infinity }}
        >
          <span className="font-serif italic text-4xl md:text-6xl lg:text-7xl text-transparent pr-8" style={{ WebkitTextStroke: "1px rgba(231,194,198,0.6)" }}>{line}</span>
          <span className="font-serif italic text-4xl md:text-6xl lg:text-7xl text-transparent pr-8" style={{ WebkitTextStroke: "1px rgba(231,194,198,0.6)" }}>{line}</span>
        </motion.div>
      </div>
    </div>
  );
};

export default Marquee;
